import { Link } from "react-router-dom";
const NotFound = () => {
  return (
    <div className="flex h-screen flex-col items-center justify-center px-4 text-center">
      <title>404 - Page Not Found</title>
      <meta name="robots" content="noindex, nofollow" />
      <h1 className="mb-4 text-6xl font-bold text-red-600">404</h1>
      <h3 className="mb-4 text-2xl font-semibold">Oops! Page Not Found</h3>
      <p className="mb-6 text-slate-300">
        The page you are looking for does not exist or has been moved.
      </p>
      <Link
        to="/"
        className="rounded bg-neutral-900 px-4 py-2 font-bold text-white hover:bg-neutral-800"
      >
        Go Back to Home
      </Link>
    </div>
  );
};

export default NotFound;
